import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { Poliza } from "../api";

interface PolizasCacheState {
  polizas: Poliza[];
  lastFetched: number | null;
  cacheExpiry: number;
  hasUserSeenModal: boolean;

  setPolizas: (polizas: Poliza[]) => void;
  addPoliza: (poliza: Poliza) => void;
  clearCache: () => void;
  isCacheValid: () => boolean;
  shouldRefetch: () => boolean;
  setHasUserSeenModal: (seen: boolean) => void;
}

const CACHE_EXPIRY_MS = 30 * 60 * 1000;

export const usePolizasCacheStore = create<PolizasCacheState>()(
  persist(
    (set, get) => ({
      polizas: [],
      lastFetched: null,
      cacheExpiry: CACHE_EXPIRY_MS,
      hasUserSeenModal: false,

      setPolizas: (polizas: Poliza[]) => {
        set({
          polizas,
          lastFetched: Date.now(),
        });
      },

      setHasUserSeenModal: (seen: boolean) => {
        set({ hasUserSeenModal: seen });
      },
      addPoliza: (poliza: Poliza) => {
        set((state) => ({
          polizas: [...state.polizas, poliza],
          hasUserSeenModal: true,
        }));
      },

      clearCache: () => {
        set({
          polizas: [],
          lastFetched: null,
          hasUserSeenModal: false,
        });
      },

      isCacheValid: () => {
        const state = get();
        if (!state.lastFetched || state.polizas.length === 0) {
          return false;
        }
        const now = Date.now();
        const elapsed = now - state.lastFetched;
        return elapsed < state.cacheExpiry;
      },

      shouldRefetch: () => {
        const state = get();
        return state.polizas.length === 0;
        // return !state.isCacheValid();
      },
    }),
    {
      name: "polizas-cache-storage",
    }
  )
);
